import React, { forwardRef } from 'react';
import { InputNumber } from 'antd';

// Saisie de montant FCFA standardisée :
// - Séparateur de milliers (espace) à l'affichage, retiré à la sauvegarde
// - Pas de valeurs négatives par défaut (min=0)
// - Suffixe "FCFA" à droite, optionnel
// - Largeur 100% par défaut, borderRadius 8 (cohérent avec le reste)
//
// Usage :
//   <Form.Item name="montant">
//     <MontantInput placeholder="Montant en FCFA" />
//   </Form.Item>
const MontantInput = forwardRef(({
    value,
    onChange,
    min = 0,
    max,
    placeholder = 'Montant',
    suffix = 'FCFA',
    style = {},
    size,
    disabled,
    autoFocus,
    onPressEnter,
    ...rest
}, ref) => {
    return (
        <InputNumber
            ref={ref}
            value={value}
            onChange={onChange}
            min={min}
            max={max}
            size={size}
            disabled={disabled}
            autoFocus={autoFocus}
            onPressEnter={onPressEnter}
            placeholder={placeholder}
            formatter={(v) => `${v}`.replace(/\B(?=(\d{3})+(?!\d))/g, ' ')}
            parser={(v) => (v || '').replace(/\s/g, '')}
            addonAfter={suffix || undefined}
            style={{ width: '100%', borderRadius: 8, ...style }}
            {...rest}
        />
    );
});

MontantInput.displayName = 'MontantInput';

export default MontantInput;
